import { loggedInTransferRx, orders, orderTracking, shop } from 'src/app/router/paths';
import { arePathnamesEqual } from 'src/app/utils';

type GetDeepLinkPathFromPathAndParams = (currentPath: string, params: { [param_key: string]: string }) => string;

export const getDeepLinkPathFromPathAndParams: GetDeepLinkPathFromPathAndParams = (currentPath, params) => {
  const isInOrderTracking = arePathnamesEqual(currentPath, orderTracking.toPath(params));
  const isInOrderHistory = arePathnamesEqual(currentPath, orders.toPath());
  const isInTransferPharmacy = arePathnamesEqual(currentPath, loggedInTransferRx.toPath());
  const isInShop = arePathnamesEqual(currentPath, shop.toPath());
  if (isInOrderTracking) {
    return `orders/${params.orderId}`;
  } else if (isInOrderHistory) {
    return `orders`;
  } else if (isInTransferPharmacy) {
    return `transferpharmacy`;
  } else if (isInShop) {
    return `shop`;
  }
  // Default to deep linking to prescriptions home page
  return `home`;
};
